import React, { useEffect, useState } from 'react';

import './style.scss';

const ScrollIndicator = ({ scrollAreaRef }) => {
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollAreaRef.current) {
        const { scrollHeight, offsetTop } = scrollAreaRef.current;
        const scrollArea = scrollHeight + offsetTop;

        if (scrollArea >= 2000) {
          const onePercent = (scrollArea - window.innerHeight) / 100;
          setWidth(window.pageYOffset / onePercent);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [scrollAreaRef]);

  return (
    <div
      className="ScrollIndicator"
      style={{
        width: `${width}%`,
      }}
    />
  );
};

export default ScrollIndicator;
